import React from "react"
import styled from "styled-components"
import {AiOutlineMail, AiOutlinePhone} from "react-icons/ai"
import useTranslation from "../utils/translation"
import {useLocale} from "../context/AppContext"
import {sizes} from "../utils/media"
import personnel from "../data/personnel"

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 24px;

  @media only screen and (max-width: ${sizes.desktop}px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (max-width: ${sizes.tablet}px) {
    grid-template-columns: 1fr;
  }
`

const Card = styled.article`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: transform 200ms ease, box-shadow 200ms ease;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }
`

const PhotoWrapper = styled.div`
  width: 100%;
  aspect-ratio: 4 / 5;
  background: #f4f4f4;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }
`

const Info = styled.div`
  padding: 16px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const Name = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #111;
  letter-spacing: 0.01em;
`

const Role = styled.p`
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 500;
  color: #6a6a6a;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`

const ContactLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #222;
  text-decoration: none;
  transition: color 150ms ease;

  svg {
    flex-shrink: 0;
    font-size: 16px;
    color: #888;
    transition: color 150ms ease;
  }

  &:hover {
    color: #000;
    text-decoration: underline;
    svg {
      color: #111;
    }
  }
`

function PersonnelCard({person}) {
  const t = useTranslation()
  const {language} = useLocale()
  const phone = (person.phone && person.phone[language]) || person.phone?.en || ""
  const phoneTel = phone.replace(/[^\d+]/g, "")

  return (
    <Card>
      <PhotoWrapper>
        <img src={person.photo} alt={person.name} loading="lazy"/>
      </PhotoWrapper>
      <Info>
        <Name>{person.name}</Name>
        <Role>{t(person.roleKey)}</Role>
        <ContactLink href={`mailto:${person.email}`}>
          <AiOutlineMail/>{person.email}
        </ContactLink>
        {phone && (
          <ContactLink href={`tel:${phoneTel}`}>
            <AiOutlinePhone/>{phone}
          </ContactLink>
        )}
      </Info>
    </Card>
  )
}

const PersonnelGrid = () => (
  <Grid>
    {personnel.map((person) => (
      <PersonnelCard key={person.email} person={person}/>
    ))}
  </Grid>
)

export default PersonnelGrid
